import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetEnrollmentRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetEnrollmentResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getEnrollment = (request: GetEnrollmentRequest, options?: CashRequestOptions) =>
  post<GetEnrollmentRequest, GetEnrollmentResponse>('/2.0/cash/get-enrollment', request, {
    ...options,
    rejectOnError: true,
  })
